import {dealerOrderStatus, dealerOrderTypes} from '../../../common/constants/lists';
import {ALL_AGENCIES} from '../../constants';

export const getOrderStatusName = (value) => {
  const requestedStatus = dealerOrderStatus.find((status) => status.value === value);
  return requestedStatus ? requestedStatus.text : value;
};

export const getOrderTypeName = (value) => {
  const requestedType = dealerOrderTypes.find((type) => type.value === value);
  return requestedType ? requestedType.text : value;
};

export const parseAgencies = (agencies, dealer = '') => {
  const filteredAgencies = agencies.filter((agency) => agency.dealerId === dealer).map(
    (agency, index) => ({'text': agency.description, 'value': agency.code, 'key': index}));

  const sortAgencies = filteredAgencies.sort((agency1, agency2) => {
    if (agency1.text === agency2.text) {
      return 0;
    }

    return agency1.text > agency2.text ? 1 : -1;
  });

  return [ALL_AGENCIES, ...sortAgencies];
};

export const transportOptions = {
  'A': 'Aéreo',
  'M': 'Marítimo',
  'V': 'VOR',
};
